import { PAxiosInstance } from "@core/types";
import axios from "axios";

import { Config as CoreConfig } from "../../../../core/src/shared/config";
import { Config as IrsKomConfig } from "../../../../IrsKom/src/shared/config";
import { Config as FoTIMEConfig } from "../../../../4time/src/shared/config";

import { Config as Parhato2Config } from "../config";
import { activeModule } from "../../../../providers/active-module";
import { authContextInstance } from "../../../../contexts/auth-context/AuthContextProvider";
import { useCustomerAddressesStorageState } from "../../../../providers/customerAddressesStorage/useCustomerAddressesStorage";
import { AppMetricaProvider } from "../../../../providers/AppMetrica/AppMetrica";

const headers = {
  "Content-Type": "application/json",
};

const modulesMap = {
  PARHATO2: Parhato2Config.baseUrl,
  "4TIME": FoTIMEConfig.baseUrl,
  IRSKOM: IrsKomConfig.baseUrl,
  CORE: CoreConfig.baseUrl,
} as any;

const baseUrl = modulesMap[activeModule as keyof typeof modulesMap];

export const httpClient = axios.create({
  baseURL: baseUrl,
  headers,
}) as PAxiosInstance;

httpClient.interceptors.request.use((config) => {
  config.headers!.Authorization = `Bearer ${httpClient.token || process.env.REACT_APP_PARHATO_2_SUPABASE_ANON_KEY}`;
  config.headers!["X-Auth-Provider"] = "supabase";
  return config;
});

httpClient.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    const status = err?.status || err.response?.status;
    if (status === 403 || status === 401) {
      useCustomerAddressesStorageState.persist.clearStorage();
      useCustomerAddressesStorageState.getState().resetAuthedCustomerAddresses();
      authContextInstance.logout();
    } else {
      AppMetricaProvider.reportError(err.message, JSON.stringify(err));
      throw err;
    }
  },
);
